import React, { ReactNode } from "react";
import "./ReportCard.scss";
import { useNavigate } from "react-router";

interface ReportCardProps {
  ReportId: string;
  Name: string;
  Description: string | ReactNode;
  className?: string;
  ButtonName?: string;
  onClick?: (e: React.MouseEvent) => void;
}

const ReportCard: React.FC<ReportCardProps> = ({
  ReportId,
  Name,
  Description,
  className,
}) => {
  const navigate = useNavigate();
  const handleCardClick = () => {
    navigate("/report/" + ReportId, {
      state: {
        title: Name,
        description: Description
      }
    });
  };

  return (
    <>
      <div
        className={`report-card${className ? " " + className : ""}`}
        onClick={() => {handleCardClick()}}
      >
        <h3 className="report-card-title">{Name}</h3>
        <div className="report-card-body">
          <div className="report-card-description">
            <p className="report-card-description-text">{Description}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportCard;
